module.exports = __webpack_public_path__ + "static/media/blogs_image.b6b12c7d.svg";